// Port of api/fuel/app/classes/insights/size/clusters.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!((((config || {}).insights || {}).size || {}).expansions)
}

function getOutlierIndexes(values) {
	if (!values.length) return []
	var mean = values.reduce(function(sum, value) { return sum + value }, 0) / values.length
	var variance = values.reduce(function(sum, value) {
		var diff = value - mean
		return sum + (diff * diff)
	}, 0) / values.length
	var deviation = Math.sqrt(variance)
	var indexes = []
	for (var i = 0; i < values.length; i++) {
		if (values[i] > mean + deviation || values[i] < mean - deviation) indexes.push(i)
	}
	return indexes
}

function emptyCluster() {
	return {
		start: 0,
		end: 0,
		added: 0,
		removed: 0,
		index: [],
		total: 0,
		games: []
	}
}

export default Segment.extend({
	name: 'clusters',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['clusters'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		if (!owner.get_count_collection()) return {}

		var exclude = excludeExpansions(vars && vars.sessionUserId)
		var clusters = {
			added: { clusters: [], total: 0 },
			removed: { clusters: [], total: 0 },
			refreshed: { clusters: [], total: 0 }
		}
		var timeline = {
			added: {},
			removed: {},
			refreshed: {}
		}
		var rolling = 4
		var minimum = 3
		var additions = Util.queryFast(
			'SELECT l.log_id AS l, g.game_id AS g, l.log_date AS d, l.log_context AS c' +
			' FROM log_user_collection l, game g' +
			' WHERE l.log_context IN(' + Util.in([Constants.LOG_CONTEXT_ADDED, Constants.LOG_CONTEXT_REMOVED]) + ')' +
			(exclude ? ' AND g.game_type = 1' : '') +
			' AND l.game_id = g.game_id' +
			' AND l.user_id = ' + owner.get_id() +
			' AND l.log_initial_sync = 0' +
			' ORDER BY l.log_date ASC, l.log_id ASC'
		)

		var minDay = 0
		var maxDay = 0
		for (var i = 0; i < additions.length; i++) {
			var addition = additions[i]
			var stamp = Util.date_start(parseInt(addition.d, 10))
			if (!minDay || stamp < minDay) minDay = stamp
			if (!maxDay || stamp > maxDay) maxDay = stamp
			if (!timeline.added[stamp]) timeline.added[stamp] = { total: 0, added: 0, removed: 0, games: [], index: [] }
			if (!timeline.removed[stamp]) timeline.removed[stamp] = { total: 0, added: 0, removed: 0, games: [], index: [] }
			if (!timeline.refreshed[stamp]) timeline.refreshed[stamp] = { total: 0, added: 0, removed: 0, games: [], index: [] }

			var changeType = parseInt(addition.c, 10) === Constants.LOG_CONTEXT_ADDED ? 'added' : 'removed'
			var gameId = parseInt(addition.g, 10)
			var logId = parseInt(addition.l, 10)
			timeline[changeType][stamp].total++
			timeline[changeType][stamp].games.push(gameId)
			timeline[changeType][stamp].index.push(logId)

			timeline.refreshed[stamp].total++
			timeline.refreshed[stamp].games.push(gameId)
			timeline.refreshed[stamp].index.push(logId)
			timeline.refreshed[stamp][changeType]++
		}

		if (minDay && maxDay) {
			for (var fillDay = minDay; fillDay <= maxDay; fillDay += Constants.TIME_DAY) {
				if (!timeline.added[fillDay]) timeline.added[fillDay] = { total: 0, added: 0, removed: 0, games: [], index: [] }
				if (!timeline.removed[fillDay]) timeline.removed[fillDay] = { total: 0, added: 0, removed: 0, games: [], index: [] }
				if (!timeline.refreshed[fillDay]) timeline.refreshed[fillDay] = { total: 0, added: 0, removed: 0, games: [], index: [] }
			}
		}

		var types = ['added', 'removed', 'refreshed']
		for (var typeIndex = 0; typeIndex < types.length; typeIndex++) {
			var clusterType = types[typeIndex]
			var candidateClusters = []
			var currentCluster = emptyCluster()
			for (var day = minDay; day <= maxDay; day += Constants.TIME_DAY) {
				var rollingTotal = 0
				for (var offset = day; offset >= day - (Constants.TIME_DAY * rolling); offset -= Constants.TIME_DAY) {
					if (timeline[clusterType][offset]) rollingTotal += timeline[clusterType][offset].total
				}

				if (rollingTotal) {
					if (!currentCluster.start) currentCluster.start = day
					currentCluster.end = day
					currentCluster.total += timeline[clusterType][day].total
					currentCluster.added += timeline[clusterType][day].added
					currentCluster.removed += timeline[clusterType][day].removed
					Array.prototype.push.apply(currentCluster.games, timeline[clusterType][day].games)
					Array.prototype.push.apply(currentCluster.index, timeline[clusterType][day].index)
				} else if (currentCluster.start) {
					currentCluster.end = day
					candidateClusters.push(currentCluster)
					currentCluster = emptyCluster()
				}
			}

			if (candidateClusters.length) {
				var totals = candidateClusters.map(function(item) { return item.total })
				var outlierIndexes = getOutlierIndexes(totals)
				for (var oi = 0; oi < outlierIndexes.length; oi++) {
					var cluster = candidateClusters[outlierIndexes[oi]]
					if (cluster.total < minimum) continue

					if (clusterType === 'refreshed') {
						if (cluster.added && cluster.removed) {
							var ratio = (1 / (cluster.added + cluster.removed)) * cluster.added
							if (ratio >= 0.3 && ratio <= 0.7) clusters[clusterType].clusters.push(cluster)
						}
					} else {
						clusters[clusterType].clusters.push(cluster)
					}
				}
			}

			if (clusters[clusterType].clusters.length) {
				clusters[clusterType].clusters = clusters[clusterType].clusters.slice().sort(function(a, b) {
					if (a.total !== b.total) return b.total - a.total
					return b.start - a.start
				})
				clusters[clusterType].total = clusters[clusterType].clusters.length
				if (clusters[clusterType].clusters.length > 5) {
					clusters[clusterType].clusters = clusters[clusterType].clusters.slice(0, detail ? 100 : 5)
				}

				for (var ci = 0; ci < clusters[clusterType].clusters.length; ci++) {
					var refs = clusters[clusterType].clusters[ci].games.slice(0, 10)
					for (var ri = 0; ri < refs.length; ri++) this._references.games.push(parseInt(refs[ri], 10))
				}
			}
		}

		if (detail) {
			return {
				clusters: clusters[vars.clusterType].clusters
			}
		}

		return {
			clusters: clusters
		}
	}
})
